export const getDefaultFeatureDropDown = `
 query GetDefaultFeatureDropDown {
  getDefaultFeatureDropDown {
    featureDropDowns {
      value
      text
    }
  }
}`;

export const getDefaultFeatureValueDropDown = `query GetDefaultFeatureValueDropDown {
  getDefaultFeatureValueDropDown {
    value
  }
}`

export const getParameterKeys = `query GetParameterKeys($request: ParameterKeysRequest!) {
  getParameterKeys(filter: $request) {
    parameterKeys {
      value
      text
    }
  }
}`

export const getLocalizationChoiceKey = `query {
  getLocalizationChoiceKey {
    choice {
      value
      text
    }
  }
}`

export const getLocalizationChoiceName = `query GetLocalizationChoiceName($filter: LocalizationChoiceDropDownRequest!) {
  getLocalizationChoiceName(filter: $filter) {
    choice {
      value
      text
    }
  }
}`

export const getLocalizationChoiceValue = `query GetLocalizationChoiceValue($filter: LocalizationChoiceDropDownRequest!) {
  getLocalizationChoiceValue(filter: $filter) {
    choice {
      value
      text
    }
  }
}`

export const getLocalizationMappingKey = `query GetLocalizationMappingKey {
  getLocalizationMappingKey {
    mapping {
      value
      text
    }
  }
}`
